import { useState, useEffect } from "react";
import { Button, Form, Input, notification, Spin } from "antd";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { get, put } from "../../../services";

const EventForm = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  const location = useLocation();
  /* Query Params to get from URL */
  const queryParams = new URLSearchParams(location.search);
  const key = queryParams.get("key");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState([]);

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // method for API call
  const getUserHandler = () => {
    setLoader(true);
    // axios call
    get(`/hr/salary/${id}`)
      .then((response) => {
        const selectedRecord = response?.data?.payPeriod[key];
        console.log("selectedRecord", selectedRecord);
        setUserData({
          ...response?.data?.payPeriod[key],
          user_id: response?.data?.employee?._id,
        });
        console.log(response);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  //  API for user
  useEffect(() => {
    getUserHandler();
    // eslint-disable-next-line
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    setLoader(true);
    const payload = {
      deductions: values?.deductions,
      baseSalary: values?.baseSalary,
      allowances: values?.allowances,
      startDate: userData?.startDate,
      endDate: userData?.endDate,
    };
    put(`/hr/salary/${id}`, payload)
      .then(() => {
        setLoader(false);
        navigate(`/salary-details/${id}`);
        openNotification("Success", "Salary Added For Employee");
      })
      .catch((error) => {
        setLoader(false);
        openNotification("Error", error?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="header">
        <h3>Edit Employee Salary</h3>
      </div>
      {!loader ? (
        <div className="form_container">
          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              deductions: userData?.deductions,
              baseSalary: userData?.baseSalary,
              allowances: userData?.allowances,
            }}
          >
            <Form.Item
              name="baseSalary"
              label="Base Salary"
              rules={[
                { required: true, message: "Please enter your Base Salary" },
              ]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item
              name="allowances"
              label="Allowances"
              rules={[
                { required: true, message: "Please enter your allowances" },
              ]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item
              name="deductions"
              label="Deductions"
              rules={[{ required: true, message: "Please enter deductions" }]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item>
              <div className="form_submit">
                <Button
                  className="back_button"
                  onClick={() => navigate("/admins")}
                >
                  Back
                </Button>
                <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className="spin_information">
          <Spin />
        </div>
      )}
    </>
  );
};
export default EventForm;
